import SpaceGroupDetails from '../components/templates/space-group-details';

export const SpaceGroupDetailsContainer = () => {
  return <SpaceGroupDetails />;
};
